import { TenantCountryCodeEnum } from 'probonio-shared-ui/api';
import { useTenant } from 'probonio-shared-ui/module/me';

export function useIsTenantOfCountry(country: TenantCountryCodeEnum): boolean {
  const { tenant } = useTenant();

  return !tenant || !country || country === tenant.countryCode;
}
